import { createFeatureGuard } from './createFeatureGuard';
import { Feature } from './Constants';

export const UploadGuard = createFeatureGuard(Feature.Upload);
